import { render, staticRenderFns } from "./RenameFeeDialog.vue?vue&type=template&id=b976a8d4&scoped=true"
import script from "./RenameFeeDialog.vue?vue&type=script&lang=js"
export * from "./RenameFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./RenameFeeDialog.vue?vue&type=style&index=0&id=b976a8d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b976a8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b976a8d4')) {
      api.createRecord('b976a8d4', component.options)
    } else {
      api.reload('b976a8d4', component.options)
    }
    module.hot.accept("./RenameFeeDialog.vue?vue&type=template&id=b976a8d4&scoped=true", function () {
      api.rerender('b976a8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/RenameFeeDialog.vue"
export default component.exports